import React, { useState } from "react";
import {
    Container,
    Card,
    Table,
    Pagination,
    Form,
    InputGroup,
    Button,
} from "react-bootstrap";


export default function AdminTodayRegistred() {

    const activeUsers = [
        {
            id: 1,
            userId: "101001",
            name: "Sarservices",
            sponsorId: "-",
            password: "1234",
            mobile: "-",
            actDate: "2026-01-26 00:00:00",
            status: "Active",
        },
        {
            id: 2,
            userId: "31790479",
            name: "Raghu",
            sponsorId: "101001",
            password: "Rag@1234",
            mobile: "8660575109",
            actDate: "2026-01-26 10:15:00",
            status: "Active",
        },
        {
            id: 3,
            userId: "31790480",
            name: "Vijay Kumar",
            sponsorId: "31790479",
            password: "Vijay@123",
            mobile: "9876543210",
            actDate: "2026-01-26 10:30:00",
            status: "Active",
        },
        {
            id: 4,
            userId: "31790481",
            name: "Karthik",
            sponsorId: "31790480",
            password: "Kar@123",
            mobile: "9123456780",
            actDate: "2026-01-26 10:45:00",
            status: "Active",
        },
        {
            id: 5,
            userId: "31790482",
            name: "Praveen",
            sponsorId: "31790481",
            password: "Pra@123",
            mobile: "9988776655",
            actDate: "2026-01-26 11:00:00",
            status: "Active",
        },
        {
            id: 6,
            userId: "31790483",
            name: "Arun Kumar",
            sponsorId: "31790482",
            password: "Arun@123",
            mobile: "9001122334",
            actDate: "2026-01-26 11:15:00",
            status: "Active",
        },
        {
            id: 7,
            userId: "31790484",
            name: "Manoj",
            sponsorId: "31790483",
            password: "Man@123",
            mobile: "9556677889",
            actDate: "2026-01-26 11:30:00",
            status: "Active",
        },
        {
            id: 8,
            userId: "31790485",
            name: "Suresh",
            sponsorId: "31790484",
            password: "Sur@123",
            mobile: "9445566778",
            actDate: "2026-01-26 11:45:00",
            status: "Active",
        },
        {
            id: 9,
            userId: "31790486",
            name: "Deepak",
            sponsorId: "31790485",
            password: "Deep@123",
            mobile: "9334455667",
            actDate: "2026-01-26 12:00:00",
            status: "Active",
        },
        {
            id: 10,
            userId: "31790487",
            name: "Harish",
            sponsorId: "31790486",
            password: "Hari@123",
            mobile: "9223344556",
            actDate: "2026-01-26 12:15:00",
            status: "Active",
        },
    ];

    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");

    const rowsPerPage = 5;

    const filteredUsers = activeUsers.filter(
        (user) =>
            user?.name?.toLowerCase().includes(search.toLowerCase()) ||
            user?.userId?.includes(search) ||
            user?.mobile?.includes(search)
    );

    const totalPages =
        Math.ceil(filteredUsers.length / rowsPerPage) || 1;

    const paginatedUsers = filteredUsers.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    const buildPages = () =>
        Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    return (
        <>
            <div className="awd-page">
                <Container fluid>
                    {/* Header */}

                    <div className="awd-header">
                        <div>
                            <h2 className="awd-main-title d-flex align-items-center">
                                Today Registered Members

                                <div className="awd-total-badge d-flex align-items-center justify-content-center mx-2">
                                    <span className="awd-total-count">
                                        {filteredUsers.length}
                                    </span>
                                </div>
                            </h2>

                        </div>
                    </div>

                    {/* Filter Bar */}

                    <Card className="awd-filter-card">
                        <div className="awd-filter-wrap">
                            <div className="awd-export-buttons">
                                <Button className="awd-export-btn">
                                    <i className="bi bi-files me-1"></i>
                                    Copy
                                </Button>

                                <Button className="awd-export-btn">
                                    CSV
                                </Button>

                                <Button className="awd-export-btn">
                                    Excel
                                </Button>

                                <Button className="awd-export-btn">
                                    PDF
                                </Button>

                                <Button className="awd-export-btn">
                                    Print
                                </Button>
                            </div>

                            <div className="awd-filter-right">
                                <InputGroup className="awd-search-box">
                                    <InputGroup.Text>
                                        <i className="bi bi-search"></i>
                                    </InputGroup.Text>

                                    <Form.Control
                                        placeholder="Search..."
                                        value={search}
                                        onChange={handleSearch}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </Card>

                    {/* Table */}

                    <Card className="ud-table-card">
                        <Card.Body className="p-0">
                            <div className="ud-scroll-wrap">
                                <Table
                                    hover
                                    borderless
                                    className="ud-table align-middle mb-0"
                                >
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>User Id</th>
                                            <th>Name</th>
                                            <th>Sponsor Id</th>
                                            <th>Password</th>
                                            <th>Mobile No</th>
                                            <th>Act Date</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paginatedUsers.length > 0 ? (
                                            paginatedUsers.map((user) => (
                                                <tr key={user.id}>
                                                    <td>{user.id}</td>
                                                    <td>{user.userId}</td>
                                                    <td>{user.name}</td>
                                                    <td>{user.sponsorId}</td>
                                                    <td>{user.password}</td>
                                                    <td>{user.mobile}</td>
                                                    <td>{user.actDate}</td>
                                                    <td>{user.status}</td>
                                                    <td className="d-flex justify-content-center align-items-center" >
                                                        <Button
                                                            size="sm"
                                                            className="global-login-btn"
                                                        >
                                                            LOGIN
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={9}
                                                    className="awd-empty-state"
                                                >
                                                    No data available in table
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>

                    {/* Footer */}

                    <div className="ud-pagination-wrap">
                        <div className="ud-pagination-wrap m-0">
                            <Pagination className="ud-pagination mb-0">
                                <Pagination.Prev
                                    disabled={page === 1}
                                    onClick={() => setPage(page - 1)}
                                />

                                {buildPages().map((p) => (
                                    <Pagination.Item
                                        key={p}
                                        active={page === p}
                                        onClick={() => setPage(p)}
                                    >
                                        {p}
                                    </Pagination.Item>
                                ))}

                                <Pagination.Next
                                    disabled={page === totalPages}
                                    onClick={() => setPage(page + 1)}
                                />
                            </Pagination>
                        </div>
                    </div>
                </Container>
            </div>
            <style>{`
.awd-total-count {
    width: 42px;
    height: 42px;
    min-width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: rgba(0, 200, 255, 0.08);
    border: 2px solid rgba(0, 200, 255, 0.16);
    color: #00a8d6;
    font-size: 15px;
    font-weight: 700;   
}

@media (max-width: 768px) {
   
}
`}</style>
        </>
    );
}